'use client';

import { Box } from 'lucide-react';
import { SectionHeader } from '../shared';

interface Collection {
  semantic_id?: string;
  name?: string;
  product_count?: number;
}

interface CollectionsSectionProps {
  collections: Collection[] | null | undefined;
  label?: string | null;
  maxItems?: number | null;
}

export function CollectionsSection({ collections, label, maxItems }: CollectionsSectionProps) {
  if (!collections || collections.length === 0) {
    return null;
  }

  const displayCollections = maxItems ? collections.slice(0, maxItems) : collections;
  const hasMore = maxItems && collections.length > maxItems;

  return (
    <div>
      <SectionHeader title={label || 'COLLECTIONS'} count={collections.length} />
      <div className="space-y-1">
        {displayCollections.map((col) => (
          <div
            key={col.semantic_id}
            className="flex items-center justify-between p-2 rounded-lg bg-card border border-border"
          >
            <div className="flex items-center gap-1.5">
              <Box className="h-3 w-3 text-muted-foreground shrink-0" />
              <span className="text-xs truncate">{col.name}</span>
            </div>
            {col.product_count != null && (
              <span className="text-xs text-muted-foreground shrink-0 ml-2">
                {col.product_count} items
              </span>
            )}
          </div>
        ))}
        {hasMore && (
          <div className="text-xs text-muted-foreground text-center py-1">
            +{collections.length - (maxItems || 0)} more
          </div>
        )}
      </div>
    </div>
  );
}
